import fs from 'fs/promises';
import path from 'path';
export class SiteFileSystem {
    rootFolderPath;
    constructor(rootFolderPath) {
        this.rootFolderPath = rootFolderPath;
    }
    getFullPath(relativePath) {
        return path.join(this.rootFolderPath, relativePath);
    }
    async readFile(filePath) {
        return fs.readFile(this.getFullPath(filePath), 'utf-8');
    }
    async writeFile(filePath, content) {
        return fs.writeFile(this.getFullPath(filePath), content);
    }
    async removeFile(filePath) {
        return fs.rm(this.getFullPath(filePath));
    }
    async readFolder(folderPath) {
        return fs.readdir(this.getFullPath(folderPath), { withFileTypes: true });
    }
    async createFolder(folderPath) {
        await fs.mkdir(this.getFullPath(folderPath), { recursive: true });
    }
    async removeFolder(folderPath) {
        return fs.rm(this.getFullPath(folderPath), { recursive: true });
    }
}
